import fetcher from '@client/core/utils/api/fetcher.js';

const sessionId = crypto.randomUUID();

export type MartailerPayload = {
  placement: string;
  visitorId: string;
  store: string;
  fake?: boolean;
  sponsoredProductsCount?: number;
  sponsoredListingsCount?: number;
  searchTerm?: string;
  sessionId?: string;
};

export type MartailerResponse = {
  sponsoredListings?: Array<MartailerProduct>; // Define proper type based on API response
  sponsoredProducts?: Array<MartailerProduct>;
};
export type MartailerProduct = {
  adId: string;
  link: string;
  price: number;
  title: string;
  brand: string;
  position: number;
  itemId: string;
  category: string;
  imageLink: string;
  organisationId: number;
  organisationName: string;
};

export type MartailerImpressionPayload = {
  adId: string;
  itemId: string;
  placement: string;
  visitorId: string;
  category: string;
  store: string;
  searchTerm?: string;
  sessionId?: string;
};

export type MartailerClickPayload = {
  adId: string;
  itemId: string;
  placement: string;
  visitorId: string;
  category: string;
  store: string;
  searchTerm?: string;
  sessionId?: string;
};

export async function callMartailerApi(
  payload: MartailerPayload
): Promise<MartailerResponse> {
  return fetcher<MartailerResponse>('/api/martailer/sponsored-catalog', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ ...payload, sessionId })
  });
}

export async function trackMartailerImpression(
  payload: MartailerImpressionPayload
): Promise<void> {
  try {
    await fetcher('/api/martailer/impression', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event: 'impression',
        ...payload,
        sessionId,
        userAgent: navigator.userAgent
      })
    });
  } catch (error) {
    console.error('Failed to track impression:', error);
  }
}

export async function trackMartailerClick(
  payload: MartailerClickPayload
): Promise<void> {
  try {
    await fetcher('/api/martailer/click', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event: 'click',
        ...payload,
        sessionId,
        pageUrl: window.location.href,
        userAgent: navigator.userAgent
      })
    });
  } catch (error) {
    console.error('Failed to track click:', error);
  }
}
